import React, { useState } from 'react';
import {
  BrioModal, BrioModalBody, BrioModalField, BrioInput, BrioSelect, BrioButton,
} from '../../components/BrioComponents';

const LUMP_TYPES = [
  { value: 'provisional_sum', label: 'Provisional sum' },
  { value: 'pc_sum', label: 'Prime-cost (PC) sum' },
  { value: 'dayworks', label: 'Dayworks' },
];

// Add a non-measured lump line (provisional sum / PC sum / dayworks): a flagged
// amount with a free-text description and no library item / take-off.
function AddLumpItemModal({ onClose, onCreate }) {
  const [lineType, setLineType] = useState('provisional_sum');
  const [description, setDescription] = useState('');
  const [quantity, setQuantity] = useState('1');
  const [rate, setRate] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const isDayworks = lineType === 'dayworks';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!description.trim()) { setError('Description is required.'); return; }
    if (rate === '' || isNaN(Number(rate)) || Number(rate) < 0) { setError('Enter a valid amount/rate.'); return; }
    setSubmitting(true);
    const result = await onCreate({
      itemVersionId: null,
      lineType,
      descriptionOverride: description,
      quantity: Number(quantity) || 1,
      rateQuoted: Number(rate),
    });
    setSubmitting(false);
    if (result.success) onClose();
    else setError(result.error || 'Failed to add line.');
  };

  const footer = (
    <>
      <BrioButton variant="secondary" onClick={onClose} disabled={submitting}>Cancel</BrioButton>
      <BrioButton variant="primary" onClick={handleSubmit} disabled={submitting}>
        {submitting ? 'Adding…' : 'Add line'}
      </BrioButton>
    </>
  );

  return (
    <BrioModal title="Add provisional / PC / dayworks line" onClose={onClose} width="md" footer={footer}>
      <BrioModalBody form>
        {error && (
          <div style={{ padding: '0.75rem 1rem', background: '#fdecec', color: '#a94442', borderRadius: 6, marginBottom: '1rem' }}>{error}</div>
        )}
        <form onSubmit={handleSubmit}>
          <BrioModalField label="Type">
            <BrioSelect value={lineType} onChange={(e) => setLineType(e.target.value)}>
              {LUMP_TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
            </BrioSelect>
          </BrioModalField>
          <BrioModalField label="Description *">
            <BrioInput value={description} onChange={(e) => setDescription(e.target.value)} autoFocus
              placeholder={isDayworks ? 'e.g. Dayworks — skilled mason' : 'e.g. Provisional sum for landscaping'} />
          </BrioModalField>
          <BrioModalField label={isDayworks ? 'Days' : 'Quantity'} hint={isDayworks ? 'Number of days' : 'Usually 1 for a lump sum.'}>
            <BrioInput type="number" step="any" min="0" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
          </BrioModalField>
          <BrioModalField label={isDayworks ? 'Day rate (estimate)' : 'Amount / rate (estimate)'}>
            <BrioInput type="number" step="any" min="0" value={rate} onChange={(e) => setRate(e.target.value)} />
          </BrioModalField>
          <div style={{ fontSize: '0.78rem', color: 'var(--brio-text-muted)' }}>
            Shown separately from measured works in summaries and excluded from cost / area.
          </div>
        </form>
      </BrioModalBody>
    </BrioModal>
  );
}

export default AddLumpItemModal;
